import { Ship } from "../../App/Ship"
import { Icons } from "../../Components/Icon"
import { UserAdviceLevel, UserAdviceRole } from "../../Components/UserAdvice/Params"
import type { SettingsWriters } from "../../Data/SettingsWriters"
import { IAppState, ILog, IShip, IShipSettings } from "../../Types"
import { FocusViewState } from "../FocusView"
import { OverlayViewDefinition } from "../OverlayView"
import { UserAdvice, UserAdviceInstance, UserAdviceLocation, UserAdviceMonitor, UserAdviceState } from "./Advice"
import { userAdviceLightsReminderOverlay } from "./LightsReminderView"

export class LightsReminderAdvice extends UserAdvice implements UserAdviceMonitor {
  readonly role = UserAdviceRole.monitor;
  private settings: IShipSettings = {} as IShipSettings;

  constructor(private readonly writers: SettingsWriters) {
    super();
  }

  update(_app: IAppState, _state: FocusViewState, _currentLog?: ILog, ship?: IShip) {
    if (ship) {
      this.settings = Ship.shipSettings(ship);
    }
  }

  isActive(): boolean {
    return this.settings.lightsReminder ?? false;
  }

  isAvailable(): boolean {
    return true;
  }

  async activate(_app: IAppState): Promise<void> {
    await this.save({ ...this.settings, lightsReminder: true });
  }

  async deactivate(_app: IAppState): Promise<void> {
    await this.save({ ...this.settings, lightsReminder: false });
  }

  async save(settings: IShipSettings): Promise<void> {
    await this.writers.updateSettings({
      lightsReminder: settings.lightsReminder ?? false,
      lightsReminderSettings: settings.lightsReminderSettings,
    });
    this.settings = settings;
  }

  getInstances(app: IAppState, location: UserAdviceLocation): UserAdviceInstance[] {
    if (location != UserAdviceLocation.toolbar) {
      return [];
    }
    const t = app.getT("UserAdviceLightsReminderView");
    return [new UserAdviceInstance(
      `lights-${location}`,
      80,
      { icon: Icons.AdviceLights, level: UserAdviceLevel.notice, title: t(this.isActive() ? "title_active" : "title_inactive"), type: "lights" },
      this,
      0,
      location,
    )];
  }

  overlay(_app: IAppState, advice: UserAdviceInstance, state: UserAdviceState): OverlayViewDefinition {
    return userAdviceLightsReminderOverlay({ advice, state, settings: this.settings, save: (settings) => this.save(settings) });
  }
}
